import type { DicMajorListFilters } from "../types";

/** 归一化筛选表单为可提交条件。 */
export function normalizeDicMajorFilters(filters: DicMajorListFilters): DicMajorListFilters {
  return {
    keyword: normalizeOptionalText(filters.keyword),
    majorCategory: normalizeOptionalText(filters.majorCategory),
    isDisabled: filters.isDisabled,
  };
}

/** 计算删除成功后应该直接回查的页码。 */
export function resolvePageAfterDelete(params: {
  currentPage: number;
  pageSize: number;
  total: number;
  currentItemCount: number;
}) {
  const nextTotal = Math.max(params.total - 1, 0);
  const nextTotalPages = Math.max(Math.ceil(nextTotal / params.pageSize), 1);
  if (params.currentItemCount <= 1 && params.currentPage > nextTotalPages) {
    return nextTotalPages;
  }
  return params.currentPage;
}

/** 归一化可选筛选文本。 */
function normalizeOptionalText(value?: string) {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
